"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9332],{

/***/ 16742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ PremiumIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44012);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(868);
/* harmony import */ var mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87452);
/* harmony import */ var mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74815);







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ",
        "px;\n  height: ",
        "px;\n  pointer-events: all;\n  cursor: help;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var PremiumIconStyle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5f2b9ec-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
var PremiumIcon = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? 12 : _size, props = _objectWithoutProperties(_param, [
        "size"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
        placement: "top",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            id: "premiumTooltip",
            defaultMessage: "Saatavilla Constle Pro -j\xe4senille"
        }),
        arrow: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PremiumIconStyle, {
            className: "premium-icon",
            size: size,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_DiamondIcon__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread({
                size: size,
                color: _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.primary */ .Il.primary
            }, props))
        })
    });
};



/***/ }),

/***/ 62653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ListSelect; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83852);
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(62822);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50998);
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46869);
/* harmony import */ var _material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95757);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17812);
/* harmony import */ var mdi_react_CheckboxMarkedIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26514);
/* harmony import */ var mdi_react_CheckboxMarkedIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mdi_react_CheckboxMarkedIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var mdi_react_CheckboxBlankOutlineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70811);
/* harmony import */ var mdi_react_CheckboxBlankOutlineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(mdi_react_CheckboxBlankOutlineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var mdi_react_MinusBoxIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54030);
/* harmony import */ var mdi_react_MinusBoxIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mdi_react_MinusBoxIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88251);
/* harmony import */ var mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var mdi_react_MenuUpIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93502);
/* harmony import */ var mdi_react_MenuUpIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(mdi_react_MenuUpIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74815);
/* harmony import */ var _Badge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44632);
/* harmony import */ var _SelectBase__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96637);

















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: ",
        ";\n  border-radius: ",
        "px;\n  overflow: hidden;\n\n  fieldset {\n    border-width: 2px;\n    border-color: ",
        ";\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  flex-shrink: 10;\n  background-color: ",
        ";\n  border-radius: 0 0 ",
        "px ",
        "px;\n  overflow: auto;\n\n  .MuiList-root {\n    padding: 0;\n  }\n\n  .MuiCollapse-container {\n    width: 100%;\n  }\n\n  .MuiCollapse-wrapperInner {\n    .MuiList-root {\n      display: flex;\n      width: 100%;\n      flex-direction: column;\n      align-items: flex-end;\n    }\n  }\n\n  .MuiListItem-root {\n    position: relative;\n    margin-top: -2px;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    border-top: 2px solid transparent;\n    border-bottom: 2px solid transparent;\n\n    box-sizing: border-box;\n\n    &:not(:last-of-type) {\n      border-bottom-color: ",
        ";\n    }\n\n    &:not(:first-of-type) {\n      border-top-color: ",
        ";\n    }\n\n    &.inner {\n      border-left: 2px solid ",
        ";\n      border-bottom-color: ",
        ";\n    }\n\n    &.expanding {\n      /** This element should ideally \"stick\" to the top if the section is expanded... */\n      padding-top: 0.5rem;\n      padding-bottom: 0.5rem;\n\n      .MuiIconButton-root {\n        position: static;\n        background-color: ",
        ";\n        border: 2px solid transparent;\n\n        box-sizing: border-box;\n\n        transition: border 30ms ease;\n\n        &.Mui-focusVisible {\n          border-color: ",
        ";\n        }\n\n        &:hover {\n          background-color: ",
        ";\n        }\n\n        /** Make the button easier to click on mobile to avoid accidental selects */\n        &:after {\n          content: '';\n          position: absolute;\n          display: block;\n          height: 100%;\n          width: 28%;\n          top: 0;\n          right: 0;\n        }\n      }\n    }\n\n    &:hover {\n      background-color: ",
        ";\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: -2px;\n        left: 0;\n        width: calc(100% - 4px);\n        height: 100%;\n        border: 2px solid ",
        ";\n        border-radius: inherit;\n        pointer-events: none;\n        z-index: 3;\n      }\n\n      &.inner::after {\n        left: -2px;\n        width: calc(100% - 2px);\n      }\n    }\n\n    &.focus {\n      background-color: ",
        ";\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: -2px;\n        left: 0;\n        width: calc(100% - 4px);\n        height: 100%;\n        border: 2px solid ",
        ";\n        border-radius: inherit;\n        pointer-events: none;\n        z-index: 3;\n      }\n\n      &.inner::after {\n        left: -2px;\n        width: calc(100% - 2px);\n      }\n    }\n\n    .badge {\n      position: absolute;\n      right: 66px;\n    }\n\n    &.Mui-selected {\n      background-color: ",
        ";\n      border-color: ",
        ";\n      border-top-color: ",
        ";\n      border-bottom-color: ",
        ";\n      color: ",
        ";\n\n      &.focus {\n        background-color: ",
        ";\n\n        &::after {\n          border-color: ",
        ";\n        }\n      }\n\n      &::before {\n        position: absolute;\n        content: '';\n        top: 0;\n        left: -2px;\n        width: 2px;\n        height: 100%;\n        background-color: ",
        ";\n      }\n\n      &:hover,\n      &.Mui-focusVisible {\n        background-color: ",
        ";\n      }\n\n      .MuiIconButton-root {\n        background-color: ",
        ";\n\n        &:hover {\n          background-color: ",
        ";\n        }\n\n        &.Mui-focusVisible {\n          border-color: ",
        ";\n        }\n      }\n\n      .badge {\n        background-color: ",
        ";\n        font-weight: 500;\n        color: ",
        ";\n\n        svg {\n          color: ",
        ";\n        }\n      }\n\n      svg {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a21b1084-0"
})(_templateObject(), function(props) {
    return props.maxHeight ? '100vh' : 'auto';
}, function(props) {
    return props.transparent ? 0 : _Theme__WEBPACK_IMPORTED_MODULE_7__/* .borderRadius */ .E0;
}, function(props) {
    return props.transparent ? 'transparent' : _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background;
}, function(props) {
    return props.transparent ? _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background : _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background;
});
var ListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a21b1084-1"
})(_templateObject1(), function(props) {
    return props.transparent ? 'transparent' : _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background;
}, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .borderRadius */ .E0, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .borderRadius */ .E0, function(props) {
    return props.transparent ? _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background : _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white;
}, function(props) {
    return props.transparent ? _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background : _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white;
}, function(props) {
    return props.transparent ? _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background : _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white;
}, function(props) {
    return props.transparent ? _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background : _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white;
}, (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .transparentize */ .DZ)(0.85, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary), _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary, (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .transparentize */ .DZ)(0.7, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary), _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.hover */ .Il.hover, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.secondary */ .Il.secondary, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.select */ .Il.select, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white, (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .darken */ ._j)(0.07, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .darken */ ._j)(0.3, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary), _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary, (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .darken */ ._j)(0.07, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .transparentize */ .DZ)(0.8, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .transparentize */ .DZ)(0.6, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white), _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.primary */ .Il.primary, _Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white);
var ItemComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var componentId = param.componentId, id = param.id, option = param.option, onSelect = param.onSelect, onOpen = param.onOpen;
    var name = option.name, index = option.index, level = option.level, isSelected = option.isSelected, selectedChildCount = option.selectedChildCount, isFocused = option.isFocused, isMatching = option.isMatching;
    var isChild = level > 0;
    var isParent = option.children.length > 0;
    // const isSearching = search.length >= SEARCH_TERM_MIN_LENGTH;
    var isOpen = option.isOpen; // || isSearching;
    var isVisible = option.isVisible; // || isSearching;
    /** Do not render anything if this item is hidden by collapse */ if (!isVisible) return null;
    /** Do not render anything if this item is hidden by search */ if (/*isSearching && */ !isMatching) return null;
    var icon = isSelected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_CheckboxMarkedIcon__WEBPACK_IMPORTED_MODULE_2___default()), {}) : selectedChildCount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_MinusBoxIcon__WEBPACK_IMPORTED_MODULE_4___default()), {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_CheckboxBlankOutlineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {});
    var style = _objectSpread({}, isChild ? {
        marginLeft: "".concat(level, "rem"),
        width: "calc(100% - ".concat(level, "rem)")
    } : {});
    var className = [
        isParent ? 'expanding' : '',
        isChild ? 'inner' : '',
        isFocused ? 'focus' : ''
    ].join(' ');
    var parentProps = isParent ? {
        'aria-expanded': isOpen
    } : {};
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, _objectSpread({
        button: true,
        id: "".concat(componentId, "-item-").concat(index),
        className: className,
        role: "treeitem",
        "aria-selected": isSelected,
        tabIndex: "-1",
        selected: isSelected,
        style: style,
        onClick: onSelect(id)
    }, parentProps, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemText__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                primary: name
            }),
            !!selectedChildCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Badge__WEBPACK_IMPORTED_MODULE_8__/* .Badge */ .C, {
                children: selectedChildCount
            }),
            isParent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                "aria-label": "avaa alavalikko",
                color: "primary",
                tabIndex: "-1",
                disableRipple: true,
                onClick: onOpen(id),
                style: {
                    padding: 6
                },
                children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_MenuUpIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                    size: 32
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                    size: 32
                })
            })
        ]
    })));
}, _SelectBase__WEBPACK_IMPORTED_MODULE_9__/* .isSelectItemStateEqual */ .fF);
var ListComponent = function(param) {
    var id = param.id, transparent = param.transparent, children = param.children;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListWrapper, {
        id: "".concat(id, "-wrapper"),
        transparent: transparent,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_List__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            id: id,
            role: "tree",
            "aria-multiselectable": true,
            children: children
        })
    }));
};
var ListSelect = function(_param) {
    var maxHeight = _param.maxHeight, transparent = _param.transparent, props = _objectWithoutProperties(_param, [
        "maxHeight",
        "transparent"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SelectBase__WEBPACK_IMPORTED_MODULE_9__/* .SelectBase */ .Ky, _objectSpread({}, props, {
        containerComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
            maxHeight: maxHeight,
            transparent: transparent
        }),
        itemComponent: ItemComponent,
        listComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListComponent, {
            id: "",
            transparent: transparent
        }),
        isParentOpenable: true,
        showSearch: true,
        showEmpty: true
    })));
};



/***/ }),

/***/ 96637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ky": function() { return /* binding */ SelectBase; },
  "fF": function() { return /* binding */ isSelectItemStateEqual; }
});

// UNUSED EXPORTS: SEARCH_TERM_MIN_LENGTH

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(33426);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(46869);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/mdi-react/MagnifyIcon.js
var MagnifyIcon = __webpack_require__(18799);
var MagnifyIcon_default = /*#__PURE__*/__webpack_require__.n(MagnifyIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/CloseIcon.js
var CloseIcon = __webpack_require__(63052);
var CloseIcon_default = /*#__PURE__*/__webpack_require__.n(CloseIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/CloseCircleOutlineIcon.js
var CloseCircleOutlineIcon = __webpack_require__(54564);
var CloseCircleOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseCircleOutlineIcon);
// EXTERNAL MODULE: ./node_modules/mdi-react/EmoticonSadOutlineIcon.js
var EmoticonSadOutlineIcon = __webpack_require__(64619);
var EmoticonSadOutlineIcon_default = /*#__PURE__*/__webpack_require__.n(EmoticonSadOutlineIcon);
// EXTERNAL MODULE: ./components/Theme.ts
var Theme = __webpack_require__(74815);
// EXTERNAL MODULE: ./components/Badge.tsx
var Badge = __webpack_require__(44632);
// EXTERNAL MODULE: ./common-react/selectOptionLogic.ts + 1 modules
var selectOptionLogic = __webpack_require__(97951);
;// CONCATENATED MODULE: ./common-react/useSelectComponent.ts


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var SEARCH_TERM_MIN_LENGTH = 3;
var useSelectComponent = function(param) {
    var componentId = param.componentId, itemsProp = param.items, selected1 = param.selected, _isParentOpenable = param.isParentOpenable, isParentOpenable = _isParentOpenable === void 0 ? false : _isParentOpenable, _locale = param.locale, locale = _locale === void 0 ? 'fi' : _locale, _single = param.single, single = _single === void 0 ? false : _single, _alwaysReturnChildren = param.alwaysReturnChildren, alwaysReturnChildren = _alwaysReturnChildren === void 0 ? false : _alwaysReturnChildren, onSelect = param.onSelect;
    var ref4 = (0,react.useState)({}), itemDictionary1 = ref4[0], _setItemDictionary = ref4[1];
    var ref1 = (0,react.useState)(''), search1 = ref1[0], setSearch = ref1[1];
    /**
   * Only used to check if incoming selected prop differs from internal selection,
   * is NOT used for select item "isSelected" state.
   */ var ref2 = (0,react.useState)([]), selectedIDs = ref2[0], setSelectedIDs = ref2[1];
    // We use a ref here to allow for functions to get the latest state without a re-render
    var itemDictionaryRef = (0,react.useRef)({});
    // Always update the ref to the latest value when rendered
    itemDictionaryRef.current = itemDictionary1;
    /** Set the item dictionary value, and update the ref value immediately */ var setItemDictionary = function(dictionary) {
        itemDictionaryRef.current = dictionary;
        _setItemDictionary(dictionary);
    };
    /** Set individual item states and merge into dictionary state */ var setItems = function(items) {
        var updatedItemDictionary = _objectSpread({}, itemDictionaryRef.current);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                updatedItemDictionary[item.id] = _objectSpread({}, item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setItemDictionary(updatedItemDictionary);
    };
    /** Helper to make accessing state with index easy */ var items1 = (0,react.useMemo)(function() {
        return Object.values(itemDictionary1).sort(function(a, b) {
            return a.index - b.index;
        });
    }, [
        itemDictionary1
    ]);
    var ref3;
    /** Helper to allow getting the focused option easy */ var focusedOption = (ref3 = items1.find(function(item) {
        return item.isFocused;
    })) !== null && ref3 !== void 0 ? ref3 : null;
    /** Helper to make checking search state easy */ var isSearching = search1.length >= SEARCH_TERM_MIN_LENGTH;
    /** Update state structure when itemsProp changes */ (0,react.useEffect)(function() {
        var dictionary = (0,selectOptionLogic/* convertItemsToState */.d8)(itemsProp, locale);
        setItemDictionary(dictionary);
    }, [
        itemsProp,
        locale
    ]);
    /** Manually override selected state, used on mount & clear */ var overrideSelectedState = function(selected) {
        var itemDictionary = itemDictionaryRef.current;
        var optionState = (0,selectOptionLogic/* getOptionSelectedStates */.cw)(selected, itemDictionary, single);
        var updatedItems = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(optionState)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (itemDictionary[item].isSelected !== optionState[item].isSelected || itemDictionary[item].selectedChildCount !== optionState[item].selectedChildCount) {
                    updatedItems.push(_objectSpread({}, itemDictionary[item], optionState[item]));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setSelectedIDs(selected);
        setItems(updatedItems);
    };
    /** Update internal selection when selected prop changes */ var selectedHash = (0,react.useMemo)(function() {
        return _toConsumableArray(selected1).sort().join(',');
    }, [
        selected1
    ]);
    (0,react.useEffect)(function() {
        var currentSelectedHash = _toConsumableArray(selectedIDs).sort().join(',');
        if (selectedHash === currentSelectedHash) return;
        overrideSelectedState(selected1);
    }, [
        selectedHash
    ]);
    /** Update visibility of items when searching */ var handleSearchChange = function(search) {
        var itemDictionary = itemDictionaryRef.current;
        var updatedItems = [];
        if (search.length >= SEARCH_TERM_MIN_LENGTH) {
            var matchingIDs = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = items1.filter(function(item) {
                    return item.parents.length === 0;
                })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value.id;
                    var _matchingIDs;
                    (_matchingIDs = matchingIDs).push.apply(_matchingIDs, _toConsumableArray((0,selectOptionLogic/* filterOption */.ok)(itemDictionary[id], search, itemDictionary)));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.values(itemDictionary)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var option = _step1.value;
                    var isMatching = matchingIDs.includes(option.id);
                    var isVisible = isMatching;
                    var isParent = option.children.length > 0;
                    var isOpen = isParent && isMatching;
                    // Update isMatching, update isOpen & remove any isFocused
                    if (option.isMatching !== isMatching || option.isVisible !== isVisible || option.isOpen !== isOpen || option.isFocused) {
                        updatedItems.push(_objectSpread({}, option, {
                            isMatching: isMatching,
                            isVisible: isVisible,
                            isOpen: isOpen,
                            isFocused: false
                        }));
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        if (isSearching && search.length < SEARCH_TERM_MIN_LENGTH) {
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = Object.values(itemDictionary)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var option1 = _step2.value;
                    var isVisible1 = option1.parents.length === 0;
                    if (option1.isOpen || !option1.isMatching || option1.isVisible !== isVisible1) {
                        updatedItems.push(_objectSpread({}, option1, {
                            isVisible: isVisible1,
                            isOpen: false,
                            isMatching: true
                        }));
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
        setSearch(search);
        setItems(updatedItems);
    };
    /** Clear search */ var handleSearchClear = function() {
        handleSearchChange('');
    };
    /** Clear selection */ var handleSearchClearSelection = function() {
        overrideSelectedState([]);
        onSelect({
            selected: [],
            count: 0
        });
    };
    /** Handle selecting an item, if is a parent item, all children will be toggled too */ var handleSelect = function(id) {
        return function(event) {
            var option = itemDictionaryRef.current[id];
            var ref = (0,selectOptionLogic/* toggleOption */._M)(option, itemDictionaryRef.current, null, single), isSelected = ref.isSelected, updatedItems = ref.updatedItems, updatedItemDictionary = ref.updatedItemDictionary;
            // The idea here is to improve first time UX by opening the selected group if it has never been opened before
            if (event && isSelected && option.children.length && !option.isTouched && !isSearching) {
                setItems(_toConsumableArray(updatedItems).concat(_toConsumableArray((0,selectOptionLogic/* toggleItemOpen */.Ps)(updatedItemDictionary[option.id], updatedItemDictionary))));
            } else {
                setItems(updatedItems);
            }
            // Get entire selection and call "onSelect" (Select parent ID only if all children are selected, if not, select child IDs only)
            var selected = (0,selectOptionLogic/* getSelectedIDs */.S0)(updatedItemDictionary, alwaysReturnChildren);
            var count = (0,selectOptionLogic/* countAllSelected */.nc)(updatedItemDictionary);
            setSelectedIDs(selected);
            onSelect({
                selected: selected,
                count: count
            });
        };
    };
    /** Handle opening an item */ var handleOpen = function(id) {
        return function(event) {
            event === null || event === void 0 ? void 0 : event.stopPropagation();
            var itemDictionary = itemDictionaryRef.current;
            var updatedItems = (0,selectOptionLogic/* toggleItemOpen */.Ps)(itemDictionary[id], itemDictionary);
            setItems(updatedItems);
        };
    };
    /** Handle keyboard focus on an item */ var focusElement = function(index) {
        var id = items1.find(function(x) {
            return x.index === index;
        }).id;
        var item = itemDictionary1[id];
        var list = document.getElementById("".concat(componentId, "-list-wrapper"));
        var element = document.getElementById("".concat(componentId, "-item-").concat(item.index));
        var scroll = list.scrollTop;
        if (index > ((focusedOption === null || focusedOption === void 0 ? void 0 : focusedOption.index) || 0)) {
            var elementScroll = element.offsetTop + element.getBoundingClientRect().height;
            if (scroll + list.getBoundingClientRect().height < elementScroll) {
                element.scrollIntoView(false);
            }
        } else {
            var elementScroll1 = element.offsetTop;
            if (elementScroll1 < scroll) {
                element.scrollIntoView(true);
            }
        }
        var updatedItems = [];
        if (focusedOption) {
            updatedItems.push(_objectSpread({}, itemDictionary1[focusedOption.id], {
                isFocused: false
            }));
        }
        updatedItems.push(_objectSpread({}, itemDictionary1[id], {
            isFocused: true
        }));
        setItems(updatedItems);
    };
    /** Move keyboard focus down, takes into account the visibility of items */ var handleFocusDown = function() {
        var _loop = function(i) {
            var item = items1.find(function(x) {
                return x.index === i;
            });
            if (!item) return "continue";
            if ((0,selectOptionLogic/* isItemVisible */.JJ)(item, isSearching, isParentOpenable)) {
                focusElement(i);
                return {
                    v: void void 0
                };
            }
        };
        if (((focusedOption === null || focusedOption === void 0 ? void 0 : focusedOption.index) || 0) >= items1.length - 1) {
            return;
        }
        for(var i = focusedOption ? focusedOption.index + 1 : 0; i < items1.length; i++){
            var _ret = _loop(i);
            if (_ret === "continue") continue;
            if (_typeof(_ret) === "object") return _ret.v;
        }
    };
    /** Move keyboard focus up, takes into account the visibility of items */ var handleFocusUp = function() {
        var _loop = function(i) {
            var option = items1.find(function(x) {
                return x.index === i;
            });
            if (!option) return "continue";
            if ((0,selectOptionLogic/* isItemVisible */.JJ)(option, isSearching, isParentOpenable)) {
                focusElement(i);
                return {
                    v: void void 0
                };
            }
        };
        // We are already at the top, do nothing
        if (!focusedOption) return;
        var item = _objectSpread({}, focusedOption);
        // We are at the last element, remove focus from list
        if (focusedOption.index === 0) {
            item.isFocused = false;
            setItems([
                item
            ]);
            return;
        }
        // Try to find the next visible element
        for(var i = focusedOption.index - 1; i >= 0; i--){
            var _ret = _loop(i);
            if (_ret === "continue") continue;
            if (_typeof(_ret) === "object") return _ret.v;
        }
        // We are at the last visible element, remove focus from list
        item.isFocused = false;
        setItems([
            item
        ]);
    };
    /** Keyboard navigation input */ var handleSearchKeyUp = function(event) {
        if (event.key === 'Enter') {
            if (!focusedOption) return;
            event.preventDefault();
            handleSelect(focusedOption.id)();
            return;
        }
        var isSelectorRight = event.target.selectionStart === event.target.value.length;
        if (event.key === 'ArrowDown' && isSelectorRight) {
            event.preventDefault();
            handleFocusDown();
            return;
        }
        if (!focusedOption) return;
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            handleFocusUp();
            return;
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            if (!isSearching && focusedOption.children.length && focusedOption.isOpen) {
                handleOpen(focusedOption.id)();
                return;
            }
            if (focusedOption.parents.length) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _toConsumableArray(focusedOption.parents).sort(function(a, b) {
                        return itemDictionary1[b].index - itemDictionary1[a].index;
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var parent = _step.value;
                        if ((0,selectOptionLogic/* isItemVisible */.JJ)(itemDictionary1[parent], isSearching, isParentOpenable)) {
                            focusElement(itemDictionary1[parent].index);
                            return;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return;
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            if (!isSearching && focusedOption.children.length && !focusedOption.isOpen) {
                handleOpen(focusedOption.id)(event);
                return;
            }
            if (focusedOption.children.length && (focusedOption.isOpen || isSearching)) {
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = focusedOption.children[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var child = _step3.value;
                        if ((0,selectOptionLogic/* isItemVisible */.JJ)(itemDictionary1[child], isSearching, isParentOpenable)) {
                            focusElement(itemDictionary1[child].index);
                            return;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            return;
        }
    };
    /** Remove selector on search blur */ var handleSearchBlur = function() {
        if (focusedOption) {
            var item = _objectSpread({}, focusedOption);
            item.isFocused = false;
            setItems([
                item
            ]);
        }
    };
    /** Only count subitems, parent is only a selector really */ var selectedCount = (0,selectOptionLogic/* countAllSelected */.nc)(itemDictionary1);
    var searchProps = {
        componentId: componentId,
        search: search1,
        selectedCount: selectedCount,
        focusedOption: focusedOption,
        onChange: handleSearchChange,
        onBlur: handleSearchBlur,
        onKeyUp: handleSearchKeyUp,
        onClearSelection: handleSearchClearSelection,
        onClear: handleSearchClear
    };
    return {
        items: items1,
        itemDictionary: itemDictionary1,
        searchProps: searchProps,
        isSearching: isSearching,
        handleSelect: handleSelect,
        handleOpen: handleOpen
    };
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
;// CONCATENATED MODULE: ./components/select/SelectBase.tsx





















function SelectBase_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SelectBase_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SelectBase_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  .MuiInputBase-root {\n    padding-top: 0.2rem;\n    padding-bottom: 0.2rem;\n    padding-left: 6px;\n    padding-right: 7px;\n    height: 60px;\n    border-radius: ",
        "px ",
        "px 0 0;\n    background-color: transparent;\n    z-index: 2;\n  }\n\n  fieldset {\n    border-width: 2px;\n    border-color: transparent;\n    border-bottom-color: ",
        ";\n  }\n\n  .search-icon {\n    padding: 12px;\n    width: 48px;\n    height: 48px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 28px;\n  font-size: 0.8rem;\n  opacity: 0.6;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  user-select: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var SelectBase_SEARCH_TERM_MIN_LENGTH = 3;
var SearchInputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-761a5930-0"
})(_templateObject(), Theme/* borderRadius */.E0, Theme/* borderRadius */.E0, Theme/* Color.background */.Il.background);
var SearchInputHint = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-761a5930-1"
})(_templateObject1());
var EmptyIndicator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-761a5930-2"
})(_templateObject2());
/** Compare select item states, can be used directly in memo */ var isSelectItemStateEqual = function(prev, next) {
    if (prev.componentId !== next.componentId) return false;
    if (prev.id !== next.id) return false;
    if (!(0,selectOptionLogic/* compareSelectItems */.qx)(prev.option, next.option)) {
        return false;
    }
    /*
  for (const child of Object.keys(next.childDictionary)) {
    if (!prev.childDictionary[child]) return false;
    if (!compareSelectItems(prev.childDictionary[child], next.childDictionary[child])) {
      return false;
    }
  }
  */ return true;
};
/**
 * The default select component search input, supports:
 * - Keyboard navigation
 * - Accessability compliance
 */ var SearchComponent = function(param) {
    var componentId = param.componentId, search = param.search, showSelectedCount = param.showSelectedCount, selectedCount = param.selectedCount, focusedOption = param.focusedOption, ariaAutocomplete = param.ariaAutocomplete, onChange = param.onChange, onBlur = param.onBlur, onKeyUp = param.onKeyUp, onClearSelection = param.onClearSelection, onClear = param.onClear;
    var intl = (0,useIntl/* default */.Z)();
    var clearTooltipMessage = intl.formatMessage({
        id: 'select.clearButton.tooltip',
        defaultMessage: 'Poista valinnat'
    });
    var clearSearchTooltipMessage = intl.formatMessage({
        id: 'select.clearSearchButton.tooltip',
        defaultMessage: 'Tyhjenn\xe4 haku'
    });
    var handleChange = function(event) {
        return onChange(event.target.value);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
            id: "".concat(componentId, "-search"),
            variant: "outlined",
            placeholder: "Hae vaihtoehdoista…",
            autoFocus: true,
            fullWidth: true,
            value: search,
            onChange: handleChange,
            onBlur: onBlur,
            onKeyUp: onKeyUp,
            InputProps: {
                id: "".concat(componentId, "-search-input"),
                'aria-autocomplete': ariaAutocomplete,
                'aria-controls': "".concat(componentId, "-list"),
                'aria-activedescendant': focusedOption ? "".concat(componentId, "-item-").concat(focusedOption.index) : '',
                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                    position: "start",
                    children: !!search ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                        title: clearSearchTooltipMessage,
                        placement: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            "aria-label": clearSearchTooltipMessage.toLowerCase(),
                            onClick: onClear,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseIcon_default()), {})
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((MagnifyIcon_default()), {
                        className: "search-icon"
                    })
                }),
                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputAdornment/* default */.Z, {
                    position: "end",
                    children: [
                        !!search && search.length < SelectBase_SEARCH_TERM_MIN_LENGTH && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputHint, {
                            children: 'Kirjoita viel\xe4 [x] kirjain(ta)'.replace('[x]', "".concat(SelectBase_SEARCH_TERM_MIN_LENGTH - search.length))
                        }),
                        !!selectedCount && !showSelectedCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            children: selectedCount
                        }),
                        !!selectedCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                            title: clearTooltipMessage,
                            placement: "left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                "aria-label": clearTooltipMessage.toLowerCase(),
                                onClick: onClearSelection,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseCircleOutlineIcon_default()), {})
                            })
                        })
                    ]
                })
            }
        })
    }));
};
var SelectBase = function(param) {
    var componentId = param.id, itemsProp = param.items, selected = param.selected, onSelect = param.onSelect, _showCount = param.showCount, showCount = _showCount === void 0 ? true : _showCount, _alwaysReturnChildren = param.alwaysReturnChildren, alwaysReturnChildren = _alwaysReturnChildren === void 0 ? false : _alwaysReturnChildren, _ariaAutocomplete = param.ariaAutocomplete, ariaAutocomplete = _ariaAutocomplete === void 0 ? 'list' : _ariaAutocomplete, containerComponent = param.containerComponent, listComponent = param.listComponent, ItemComponent = param.itemComponent, _showSearch = param.showSearch, showSearch = _showSearch === void 0 ? false : _showSearch, searchComponent = param.searchComponent, _showEmpty = param.showEmpty, showEmpty = _showEmpty === void 0 ? false : _showEmpty, emptyComponent = param.emptyComponent, _isParentOpenable = param.isParentOpenable, isParentOpenable = _isParentOpenable === void 0 ? false : _isParentOpenable, _renderListItems = param.renderListItems, renderListItems = _renderListItems === void 0 ? null : _renderListItems, _className = param.className, className = _className === void 0 ? '' : _className, children = param.children;
    var locale = (0,router.useRouter)().locale;
    var ref = useSelectComponent({
        componentId: componentId,
        items: itemsProp,
        selected: selected,
        alwaysReturnChildren: alwaysReturnChildren,
        isParentOpenable: isParentOpenable,
        locale: locale,
        onSelect: onSelect
    }), items = ref.items, itemDictionary = ref.itemDictionary, searchProps = ref.searchProps, isSearching = ref.isSearching, handleSelect = ref.handleSelect, handleOpen = ref.handleOpen;
    /** Render a list item */ var renderListItem = (0,react.useCallback)(function(option) {
        var id1 = option.id, index = option.index;
        var itemProps = {
            componentId: componentId,
            id: id1,
            option: option,
            childDictionary: option.children.reduce(function(dictionary, id) {
                return SelectBase_objectSpread({}, dictionary, SelectBase_defineProperty({}, id, itemDictionary[id]));
            }, {}),
            onSelect: handleSelect,
            onOpen: handleOpen
        };
        return(/*#__PURE__*/ (0,react.createElement)(ItemComponent, SelectBase_objectSpread({}, itemProps, {
            key: "".concat(componentId, "-option-").concat(index)
        })));
    }, [
        isSearching,
        itemDictionary
    ]);
    /** Render all list items */ var listItems = renderListItems ? renderListItems(items, itemDictionary, handleSelect, handleOpen) : items.map(renderListItem);
    /** Show a frown face is list is empty :( */ var isListEmpty = !listItems.length;
    var allSearchProps = SelectBase_objectSpread({}, searchProps, {
        showSelectedCount: showCount,
        ariaAutocomplete: ariaAutocomplete
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(containerComponent.type, SelectBase_objectSpread({}, containerComponent.props, {
        id: componentId,
        className: className,
        children: [
            showSearch && (searchComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(searchComponent.type, SelectBase_objectSpread({}, searchComponent.props, searchProps)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchComponent, SelectBase_objectSpread({}, allSearchProps))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(listComponent.type, SelectBase_objectSpread({}, listComponent.props, {
                id: "".concat(componentId, "-list"),
                className: "select-list",
                children: [
                    listItems,
                    isListEmpty && showEmpty && (emptyComponent || /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyIndicator, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((EmoticonSadOutlineIcon_default()), {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: "Ei tuloksia haulle"
                                })
                            ]
                        })
                    }))
                ]
            })),
            children
        ]
    })));
};


/***/ })

}]);